angular.module('natgeo').controller('SplashFactoryScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'SoundEngine', 
function SplashFactoryScreen($scope, element, ScreenFactory, manager, container, SoundEngine)
{
	var screen = ScreenFactory( 'splash_factory', element );
	
  $scope.next = function()
  {
    $manager.transition('splash_menu');
  };

  // Beginning of the screen, play the whip!
  screen.on('introBegin', function()
  {
    SoundEngine.play( 'whip', {delay:1000} );
  });

}]);